/** Libellés FR/EN — classes, événements, présences Phase 1 */

export const CLASS_CATEGORIES = {
  enfants: { fr: "Enfants", en: "Children" },
  ados: { fr: "Adolescents", en: "Teens" },
  adultes: { fr: "Adultes", en: "Adults" },
  competition: { fr: "Compétition", en: "Competition" },
  ceintures_avancees: { fr: "Ceintures avancées", en: "Advanced belts" },
};

export const EVENT_TYPES = {
  seminaire: { fr: "Séminaire", en: "Seminar" },
  stage: { fr: "Stage", en: "Training camp (weekend)" },
  camp: { fr: "Camp", en: "Camp" },
  demonstration: { fr: "Démonstration", en: "Demonstration" },
  examen: { fr: "Examen (à venir)", en: "Exam (coming soon)" },
  competition: { fr: "Compétition (à venir)", en: "Competition (coming soon)" },
};

export const ATTENDANCE_STATUSES = {
  present: { fr: "Présent", en: "Present" },
  absent: { fr: "Absent", en: "Absent" },
  a_confirmer: { fr: "À confirmer", en: "To confirm" },
  non_suivi: { fr: "Non suivi", en: "Not tracked" },
};

export const PHASE_LABELS = {
  phase1: { fr: "Phase 1", en: "Phase 1" },
  phase2: { fr: "Phase 2", en: "Phase 2" },
  futur: { fr: "Futur", en: "Future" },
};

export const WEEKDAYS = {
  lundi: { fr: "Lundi", en: "Monday" },
  mardi: { fr: "Mardi", en: "Tuesday" },
  mercredi: { fr: "Mercredi", en: "Wednesday" },
  jeudi: { fr: "Jeudi", en: "Thursday" },
  vendredi: { fr: "Vendredi", en: "Friday" },
  samedi: { fr: "Samedi", en: "Saturday" },
  dimanche: { fr: "Dimanche", en: "Sunday" },
};

/**
 * @param {Record<string, { fr: string, en: string }>} map
 * @param {string} key
 * @param {'fr'|'en'} locale
 */
export function labelFromMap(map, key, locale = "fr") {
  const entry = map[key];
  if (!entry) return key;
  return locale === "en" ? entry.en : entry.fr;
}
